import React from 'react';
import {Table} from 'src/design/atoms/Table';
import {Box} from 'src/design/atoms/Box';
import {Text} from 'src/design/atoms/Text';
import {Pill} from 'src/design/atoms/Pill';
import {CourseAssignmentStatePill} from 'src/shared/constants/PillConstants';
import {useGetCourseAssignmentListV2Query} from 'src/redux/queries/courseAssignment';
import {parseUtcDate} from 'src/shared/utils/parseUtcDate';

export interface PersonAssignmentsPanelProps {
  userId: number;
}

/**
 * Row-expand detail panel for the by-person compliance pivot: the person's
 * individual assignments (`sessionUserId` filter on the V2 list endpoint).
 */
export const PersonAssignmentsPanel: React.FC<PersonAssignmentsPanelProps> = ({
  userId,
}) => {
  const {data, isFetching} = useGetCourseAssignmentListV2Query({
    start: 0,
    length: 100,
    filters: [],
    filterFns: [],
    sorting: [],
    sessionUserId: userId,
  });
  const assignments = data?.data ?? [];

  if (isFetching) {
    return (
      <Box px="xl" py="md">
        <Text c="dimmed">Loading assignments...</Text>
      </Box>
    );
  }

  return (
    <Box px="xl" py="md">
      <Table striped withTableBorder={false}>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Course</Table.Th>
            <Table.Th>State</Table.Th>
            <Table.Th>Due</Table.Th>
            <Table.Th>Days Past Due</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {assignments.map(assignment => (
            <Table.Tr key={assignment.id}>
              <Table.Td>{assignment.courseDefinition?.name}</Table.Td>
              <Table.Td>
                {assignment.state !== undefined && (
                  <Pill {...CourseAssignmentStatePill(assignment.state)} />
                )}
              </Table.Td>
              <Table.Td>
                {assignment.dueAt
                  ? parseUtcDate(assignment.dueAt).toLocaleDateString()
                  : ''}
              </Table.Td>
              <Table.Td>{assignment.daysPastDue ?? ''}</Table.Td>
            </Table.Tr>
          ))}
          {assignments.length === 0 && (
            <Table.Tr>
              <Table.Td colSpan={4}>
                <Text c="dimmed">No assignments.</Text>
              </Table.Td>
            </Table.Tr>
          )}
        </Table.Tbody>
      </Table>
    </Box>
  );
};
